export default __webpack_public_path__ + "static/media/bike-hire.10af27bc.svg";